{
    "name": "mediahaven",
    "version": "26.1.34",
    "license": "MIT",
    "private": true,
    "scripts": {
        "ng": "ng",
        "nx": "nx",
        "start": "pnpm run exec start",
        "analyze": "pnpm run exec analyze",
        "library-report": "npx ts-node tools/scripts/library-usage-report.ts",
        "preinstall": "npx only-allow pnpm",
        "postinstall": "pnpm run exec postinstall",
        "build": "ng build",
        "build:stats": "pnpm run exec build:stats",
        "test": "nx test",
        "test-all": "npm-run-all -s \"test-once-ci stylehaven-components\" \"test-once-ci shared\" \"test-once-ci digihaven-shared\" \"test-once-ci mediahaven2\" \"test-once-ci portal\" \"test-once-ci management\" \"test-once-ci serieregister\" \"test-once-ci edepot\" \"test-once-ci depot-management\" \"test-once-ci archive-management\"",
        "test-mediahaven": "npm-run-all -s \"test-once-ci stylehaven-components\" \"test-once-ci shared\" \"test-once-ci mediahaven2\" \"test-once-ci portal\" \"test-once-ci management\"",
        "test-digihaven": "npm-run-all -s \"test-once-ci stylehaven-components\" \"test-once-ci digihaven-shared\" \"test-once-ci serieregister\" \"test-once-ci edepot\" \"test-once-ci depot-management\" \"test-once-ci archive-management\"",
        "e2e": "ng e2e",
        "affected:apps": "nx affected:apps",
        "affected:libs": "nx affected:libs",
        "affected:build": "nx affected:build",
        "affected:e2e": "nx affected:e2e",
        "affected:test": "nx affected:test",
        "affected:lint": "nx affected:lint",
        "affected:dep-graph": "nx affected:dep-graph",
        "affected": "nx affected",
        "lint": "nx workspace-lint && nx lint",
        "format": "nx format:write",
        "format:check": "nx format:check",
        "update": "nx migrate latest",
        "workspace-generator": "nx workspace-generator",
        "dep-graph": "nx dep-graph",
        "help": "nx help",
        "exec": "node exec",
        "test-once-ci": "pnpm run exec test-once-ci",
        "integration-report": "node ./testing/configs/cucumber.report.js",
        "integration": "pnpm run exec integration",
        "integration-without-build": "pnpm run exec integration-without-build",
        "integration-run": "pnpm run exec integration-run",
        "integration-test": "pnpm run exec integration-test",
        "integration-update": "pnpm run exec integration-update",
        "integration-setup": "pnpm run exec integration-setup",
        "integration-typescript-setup": "pnpm run exec integration-typescript-setup",
        "integration-servers": "pnpm run exec integration-servers",
        "integration-start-frontend": "pnpm run exec integration-start-frontend",
        "integration-start-backend": "pnpm run exec integration-start-backend",
        "integration-start-backend-listener": "pnpm run exec integration-start-backend-listener",
        "install-hooks": "node scripts/hooks/pre-commit.js",
        "performance-test": "pnpm run exec performance-test",
        "performance-setup": "pnpm run exec performance-setup",
        "performance-run": "pnpm run exec performance-run",
        "performance": "pnpm run exec performance",
        "set-env": "pnpm run exec set-env",
        "set-integration-env": "pnpm run exec set-integration-env",
        "set-development-env": "pnpm run exec set-development-env",
        "start-offline": "pnpm run exec start-offline",
        "start-stylehaven-core": "pnpm run start --prefix ./libs/stylehaven-core/",
        "build-stylehaven-core": "pnpm run build --prefix ./libs/stylehaven-core/",
        "workspace-schematic": "nx workspace-schematic",
        "sonar": "sonar-scanner -Dsonar.host.url=$SONAR_HOST_URL -Dsonar.login=$SONAR_LOGIN",
        "check-translations-format": "node check-translations-format",
        "list-most-edited-files": "git log --pretty=format: --name-only | sort | uniq -c | sort -rg | grep '/' | grep -v '.json$' | grep -v 'libs/language/*' | grep -v 'testing/*' | head -30"
    },
    "dependencies": {
        "@angular/animations": "^18.2.14",
        "@angular/common": "^18.2.14",
        "@angular/compiler": "^18.2.14",
        "@angular/core": "^18.2.14",
        "@angular/forms": "^18.2.14",
        "@angular/google-maps": "^21.0.5",
        "@angular/platform-browser": "^18.2.14",
        "@angular/platform-browser-dynamic": "^18.2.14",
        "@angular/router": "^18.2.14",
        "@apollo/client": "^3.14.0",
        "@aws-crypto/sha256-js": "^5.2.0",
        "@duxor/agm-core": "^18.0.0",
        "@googlemaps/markerclusterer": "^2.6.2",
        "@huntsman-cancer-institute/angular-tree-component": "^13.0.1",
        "@ngrx/entity": "18.1.1",
        "@ngrx/store": "18.1.1",
        "@ngx-file-upload/core": "^9.0.0",
        "@ngx-translate/core": "^15.0.0",
        "@sentry/angular-ivy": "^7.120.4",
        "apollo-angular": "^7.2.1",
        "buffer": "^6.0.3",
        "commons-validator-js": "^1.0.1669",
        "core-js": "^3.47.0",
        "date-fns": "^2.30.0",
        "details-element-polyfill": "^2.4.0",
        "edtf": "4.6.0",
        "element-closest-polyfill": "^1.0.7",
        "fast-equals": "^2.0.4",
        "file-saver": "^2.0.5",
        "filesize": "^10.1.6",
        "formdata-polyfill": "^3.0.20",
        "libphonenumber-js": "^1.12.33",
        "lodash-es": "^4.17.22",
        "mime": "^4.1.0",
        "myna-parser": "^2.5.1",
        "ng-let": "^17.0.4",
        "ngrx-store-localstorage": "^18.0.0",
        "ngx-clipboard": "~15.0.1",
        "ngx-drag-drop": "^18.0.2",
        "ngx-extended-pdf-viewer": "~24.2.5",
        "ngx-image-cropper": "^7.2.1",
        "ngx-infinite-scroll": "^20.0.0",
        "ngx-printer": "^1.8.0",
        "ngx-translate-messageformat-compiler": "^7.2.0",
        "postal-mime": "^1.1.0",
        "replaywebpage": "^2.4.0",
        "rxjs": "^6.6.7",
        "tslib": "^2.8.1",
        "video.js": "^7.21.7",
        "zone.js": "^0.15.1"
    },
    "devDependencies": {
        "@angular-devkit/architect": "^0.2101.0",
        "@angular-devkit/build-angular": "~18.2.21",
        "@angular-devkit/core": "~18.2.21",
        "@angular-devkit/schematics": "~18.2.21",
        "@angular-eslint/eslint-plugin": "^19.8.1",
        "@angular-eslint/eslint-plugin-template": "^19.8.1",
        "@angular-eslint/template-parser": "^19.8.1",
        "@angular/cli": "^18.2.21",
        "@angular/compiler-cli": "^18.2.14",
        "@angular/language-service": "^18.2.14",
        "@cucumber/cucumber": "^11.3.0",
        "@cucumber/gherkin": "^29.0.0",
        "@cucumber/pretty-formatter": "^1.0.1",
        "@eslint/eslintrc": "^2.1.1",
        "@eslint/js": "~8.57.0",
        "@ngrx/store-devtools": "^18.1.1",
        "@nx/angular": "~22.2.0",
        "@nx/eslint-plugin": "~22.2.0",
        "@nx/jest": "~22.2.0",
        "@nx/js": "~22.2.0",
        "@playwright/test": "^1.57.0",
        "@schematics/angular": "~18.2.21",
        "@swc-node/register": "~1.10.0",
        "@swc/core": "~1.10.0",
        "@swc/helpers": "~0.5.18",
        "@types/file-saver": "^2.0.7",
        "@types/google.analytics": "0.0.46",
        "@types/google.maps": "^3.58.1",
        "@types/jasmine": "4.6.6",
        "@types/jest": "^29.5.14",
        "@types/lodash-es": "^4.17.12",
        "@types/node": "18.19.130",
        "@types/video.js": "^7.3.58",
        "@typescript-eslint/eslint-plugin": "^8.40.0",
        "@typescript-eslint/parser": "^8.40.0",
        "cross-env": "~7.0.3",
        "cucumber-html-reporter": "^6.0.0",
        "eslint": "^9.8.0",
        "eslint-config-prettier": "^10.0.0",
        "express": "^4.22.1",
        "fast-xml-parser": "^5.3.3",
        "globals": "^17.0.0",
        "http-proxy-middleware": "^2.0.9",
        "jest": "^29.7.0",
        "jest-environment-jsdom": "^29.7.0",
        "jest-preset-angular": "~14.5.5",
        "karma": "^6.4.4",
        "karma-chrome-launcher": "~3.2.0",
        "karma-coverage": "^2.2.1",
        "karma-coverage-istanbul-reporter": "~3.0.3",
        "karma-jasmine": "5.1.0",
        "karma-jasmine-html-reporter": "2.1.0",
        "karma-junit-reporter": "^2.0.1",
        "karma-spec-reporter": "0.0.36",
        "mkdirp": "^1.0.4",
        "morgan": "^1.10.1",
        "multer": "^2.0.2",
        "ng-mocks": "^14.15.0",
        "nodemon": "^3.1.11",
        "npm-run-all2": "^5.0.2",
        "nx": "~22.2.0",
        "playwright": "^1.57.0",
        "playwright-expect": "^0.1.2",
        "prettier": "^3.7.4",
        "run": "^1.5.0",
        "sass": "^1.97.1",
        "seedrandom": "^3.0.5",
        "sonar-scanner": "^3.1.0",
        "ts-jest": "^29.4.6",
        "ts-morph": "^27.0.2",
        "ts-node": "^10.9.2",
        "typescript": "^5.5.4",
        "typescript-eslint": "^8.40.0",
        "webpack": "^5.104.1",
        "webpack-bundle-analyzer": "^4.10.2",
        "yargs": "^16.2.0"
    }
}
